<template>
	<div class="col-md-12 col-sm-12 col-xs-12" style="padding-bottom: 50px;">
		<div v-show="loaded">
			<div class="row">
				<div class="form-header">
					<p>{{ tips }}</p>
				</div>
			</div>
			<div class="company-account">
				<trans-account-row v-for="(item, index) in accountList" :key="item.bank_account" :item="item" :last="index == accountList.length - 1">
				</trans-account-row>
			</div>
		</div>
	</div>
</template>

<script>
import TransAccountRow from '@/components/TransAccountRow'
import { mapGetters } from 'vuex'

export default {
	name: 'TransAccounts',
	data: () => ({
		'loaded': false,
		'showSummary': false,
		'tips': null
	}),
	computed: {
		...mapGetters({
			role: 'getRole',
			order: 'getOrder',
			accountList: 'getAccounts'
		}),
		isCustomer () {
			return this.role === 'customer'
		}
	},
	components: {
		TransAccountRow
	},
	created: function () {
		if (this.$route.name === 'TransAccountsHelp') {
			this.tips = '我司收款账号清单'
			this.setPageTitle('我司收款账号')
		} else {
			this.tips = '请先选择您转账到的公司账号'
			this.setPageTitle('查账信息登记')
		}
	},
	mounted: function () {
		this.$store.dispatch('clearPayment', {})
		this.$store.dispatch('clearSelectedPayway', {})
		this.showSummary = this.order.paid_price > 0
		if (this.accountList.length === 0) {
			this.loadAccounts()
		} else {
			this.loaded = true
		}
	},
	methods: {
		loadAccounts () {
			this.loading('正在读取...')
			this.$http.get('/api/integration/trans/accounts').then(response => {
				console.log(response)
				this.loadingHide()
				var rs = response.body
				if (rs.code === 0) {
					this.$store.dispatch('setTxAccountList', {'items': rs.data})
					this.loaded = true
				} else {
					this.handleHttpError(response)
				}
			}, response => {
				console.log(response)
				this.handleHttpError(response)
			})
		}
	}
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/payment/TransAccounts.vue